import React, { useEffect, useState } from 'react'
import Video from '../Video'
import {
  container,
  videoTitle,
  videoSubtitle,
  videoPreview,
  videoDarkMode,
  videoImageContainer,
  videoImageTextContainer,
  videoTextContainer,
  videoButton,
} from './index.module.css'
import BackgroundImage from 'gatsby-background-image'
import useWindowSize from '../../hooks/useWindowSize'

const FeatureVideoPlayer = ({
  nodeLocale,
  video_ref,
  subtitle,
  title,
  backgroundColor,
  isDarkTheme,
  images,
  ctaText,
  ctaUrl,
}) => {
  const videoId = video_ref && video_ref.videoId
  const videoPlaylistId = video_ref && video_ref.videoPlaylistId
  const videoUrl = video_ref && video_ref.videoUrl
  const videoBackgroundImage = video_ref && video_ref.backgroundImage
  const videoAutoplay = video_ref && video_ref.autoplay
  subtitle = subtitle && subtitle.subtitle
  const videoOpts = {
    playerVars: {
      list: videoPlaylistId,
      modestbranding: 1,
      autoplay: videoAutoplay ? 1 : 0,
      rel: 0,
    },
  }

  const [toggleStyle, setToggleStyle] = useState(false)
  const { width } = useWindowSize()
  const [isMobile, setMobile] = useState(false)
  useEffect(() => {
    setMobile(width <= 1024)
    if (isMobile) {
      setToggleStyle(false)
    }
  }, [width, isMobile])
  const img = images ? images[0] : null
  const backgroundFluidImageStack = img
    ? [`linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))`, img.fluid]
    : null
  const handleClick = (e) => {
    setToggleStyle(!toggleStyle)
  }

  return (
    <div
      className={isDarkTheme ? videoDarkMode : ''}
      style={{ backgroundColor: backgroundColor }}
    >
      <div className="wrapper">
        <div className={container}>
          <div className={videoTextContainer}>
            {title && (
              <h1
                className={videoTitle}
                style={{ display: isMobile ? 'none' : 'block' }}
              >
                {title}
              </h1>
            )}
            {subtitle && (
              <div
                className={videoSubtitle}
                style={{ display: isMobile ? 'none' : 'block' }}
              >
                {subtitle}
              </div>
            )}
          </div>

          <div className={videoPreview}>
            {!isMobile ? (
              <Video
                videoId={videoId}
                videoOpts={videoOpts}
                videoUrl={videoUrl}
                videoBackgroundImage={videoBackgroundImage}
                nodeLocale={nodeLocale}
              />
            ) : (
              <>
                {img && backgroundFluidImageStack ? (
                  <>
                    <BackgroundImage
                      className={videoImageContainer}
                      fluid={backgroundFluidImageStack}
                      style={{ display: toggleStyle ? 'none' : 'block' }}
                    >
                      <div className={videoImageTextContainer}>
                        {title && <h1>{title}</h1>}
                        {ctaUrl && (
                          <button onClick={handleClick} className={videoButton}>
                            {ctaUrl}
                          </button>
                        )}
                      </div>
                    </BackgroundImage>
                    <div style={{ display: toggleStyle ? 'block' : 'none' }}>
                      <Video
                        videoId={videoId}
                        videoOpts={videoOpts}
                        videoUrl={videoUrl}
                        videoBackgroundImage={videoBackgroundImage}
                        nodeLocale={nodeLocale}
                      />
                    </div>
                  </>
                ) : (
                  <Video
                    videoId={videoId}
                    videoOpts={videoOpts}
                    videoUrl={videoUrl}
                    videoBackgroundImage={videoBackgroundImage}
                    nodeLocale={nodeLocale}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeatureVideoPlayer
